import { FileActionButton } from "../file-action/file-action-controls";
import { Suspense, useState ,useRef} from 'react';
import AppLoading from '../app-loading/app-loading';
import GSTSalesReportsListSearch from './gst-sales-report-search';
import GSTSalesReportListDataTable from './gst-sales-report-datatabel';
import reportsServices from '../../services/reports/reportservice';
import { DataTableStateEvent } from "primereact/datatable";
import { gstSalesReportsExport } from './gst-sales-report-export';
import { Toast } from 'primereact/toast';

const GSTSalesReportsList = () => {

    const [loading, setLoading] = useState(false);
    const [gstSalesList,setGstSalesList] = useState<any>([]);
    const [totalRecordsCount,setTotalRecordsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [startDate,setStartDate] = useState<any>();
    const [endDate,setendDate] = useState<any>();
    const [userId,setUserId] = useState<any>();
    const [invoiceNumber,setInvoiceNumber] = useState<any>();
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const toast = useRef<Toast>(null);

   const handleSearch = async (query: any) => {
        setLoading(true);
        try {
            if(query.fromDate != null || query.toDate != null)
            {
                setStartDate(query.fromDate );
                setendDate(query.toDate);
                setUserId(query.userId);
                setInvoiceNumber(query.invoiceNo);
                const response = await reportsServices.gstGSTSalesReportsList(query);
                if(response.salesReport.length > 0){
                    setGstSalesList(response.salesReport);
                    setTotalRecordsCount(response.totalRecords)
                }
            }
            else{
                    toast.current?.show({
                    severity: 'info',
                    summary: 'info',
                    detail: 'Please select Date filter',
                    life: 3000
                    });
                 }
        } catch (error) {
            console.error('Error fetching GST Sales Report:', error);
        } finally {
            setLoading(false);
        }
    };

        const handlePageChange = (event: DataTableStateEvent) => {
            const newPageNumber = Math.floor((event.first || 0) / (event.rows || 10)) + 1;
            const newPageSize = event.rows || 10;
            setPageNumber(newPageNumber);
            setPageSize(newPageSize);
            handleSearch({
                pageNumber: newPageNumber,
                pageSize: newPageSize,
                fromDate : startDate,
                toDate : endDate,
                userId : userId
            });
        };
    
        const handleExport = async () => {
            try {
                setExportLoading(true);
                    await gstSalesReportsExport(
                     userId,
                     startDate,
                     endDate,
                     invoiceNumber
                    );
                } catch (error) {
                    console.error('Detail export failed:', error);
                }
                setExportLoading(false);
        }

    return (
        <Suspense fallback={<AppLoading />}>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">                
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">GST Sales Report</h5>
                        <FileActionButton action="export"
                            className="text-black border-round"
                            onClick={handleExport}
                            icon={exportLoading ? "pi pi-spin pi-spinner mr-1" : "pi pi-file-export mr-1"}
                            disabled={exportLoading}
                            text
                            raised
                        >
                            Export GST Sales Reports
                        </FileActionButton>
                    </div>
                </div>
                <GSTSalesReportsListSearch onSearch={handleSearch} setLoading={setLoading}/>
                <GSTSalesReportListDataTable 
                    data={gstSalesList} 
                    totalRecords={totalRecordsCount} 
                    pageNumber={pageNumber}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                />   
            </div>
            {loading && <AppLoading />}
        </Suspense>
    );
};

export default GSTSalesReportsList;